import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	MessageList,
	Message,
	MessageText,
	MessageGroup,
	MessageButtons,
	MessageButton,
	MessageTitle,
	MessageMedia,
	Bubble,
} from '@livechat/ui-kit'
import { isMobile } from 'react-device-detect';
import parse from "html-react-parser";
import ConfirmDrawer from './ConfirmDrawer';
import { getCurrentAgent } from '../redux/reducers/users';

const MessageHistory = ({
	events,
	ownId,
	sendMessage,
	chatState,
	onMessageSend,
	users,
	currentAgent,
	minimize,
	maximizeChatWidget,
	rateGood,
	rateBad,
	rate,
}) => {
	const [visible, setVisible] = useState(false);

	const agentName = useSelector(state => getCurrentAgent(state));

	const endChatClicked = () => {
		window.parent.postMessage('endChat', '*');
		setVisible(false);
	}
    return (
		<>
			{/* <Button type="primary" onClick={() => setVisible(true)}>
				Open
			</Button> */}
			<MessageList active containScrollInSubtree>
				{events.map((messageGroup, index) => (
					<MessageGroup key={index}>
						{messageGroup.map((message, index) => (
							<Message
								// avatarUrl={'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50'}
								date={message.parsedDate}
								isOwn={message.authorId === ownId || message.own === true}
								authorName={message.own === true ? '' : agentName}
								key={index}
							>
								<Bubble isOwn={message.authorId === ownId || message.own === true} className={message.own ? 'primary-color text-container own' : 'text-container agent'}>
									{message.title && <MessageTitle title={message.title} />}
									{(message.imageUrl && message.type === 'imagebefore') && (
										<MessageMedia>
												{
												message.type === 'imagebefore' && (
													<img src={message.imageUrl} alt=''/>
												)
											}
										</MessageMedia>
									)}
									{message.text && <MessageText>{message.text}</MessageText>}
									{message.imageUrl && (
										<MessageMedia>
												{
												message.type === 'image' && (
													<img src={message.imageUrl} alt=''/>
												)
											}
											{
												message.type === 'link' && (
													<>{
														parse(message.imageUrl)
													}
													</>
												)
											}
										</MessageMedia>
									)}
									{message.buttons &&
										message.buttons.length !== 0 && (
											<MessageButtons>
												{message.buttons.map((button, buttonIndex) => (
													<MessageButton
														key={buttonIndex}
														label={button.title}
														onClick={() => {
															sendMessage(button.postback)
														}}
													/>
												))}
											</MessageButtons>
									)}
								</Bubble>
							</Message>
						))}
					</MessageGroup>
				))}
			</MessageList>
			{isMobile &&
				<ConfirmDrawer
					visible={visible}
					onOk={endChatClicked}
					onCancel={() => setVisible(false)}
				/>
			}
		</>
    );
}

export default MessageHistory;